import { useGetClientByIdQuery } from '@entities/clients/rtk-query.ts';
import cn from 'classnames';
import type React from 'react';
import { Link } from 'react-router-dom';
import { useClientAboutPageRedirect } from '@pages/clients/client-about-page/helpers.ts';
import { ArrowRightSmall } from '@shared/assets/index.ts';
import { IconButton } from '@shared/ui/index.ts';
import { Loader } from '@src/library/components/common/index.ts';
import * as st from './styles.module.scss';

type Props = {
  id: number;
};

export const Profile: React.FC<Props> = ({ id }) => {
  const { data: client, isLoading } = useGetClientByIdQuery(id);
  const { doSavePageUrl } = useClientAboutPageRedirect();
  const birth_d: Date | undefined = client?.birth_date ? new Date(client.birth_date) : undefined;

  const created_d: Date | undefined = client?.date_created
    ? new Date(client.date_created)
    : undefined;
  const registered_d: Date | undefined = client?.date_registered
    ? new Date(client.date_registered)
    : undefined;

  // const dateFunc = (): string => {
  //   return registered_d !== undefined
  //     ? `${registered_d.getDate()} ${
  //         monthNames[registered_d.getMonth()]
  //       } ${registered_d.getFullYear()}`
  //     : created_d !== undefined
  //       ? `${created_d.getDate()} ${monthNames[created_d.getMonth()]} ${created_d.getFullYear()}`
  //       : '';
  // };

  // useEffect(() => {
  //   dateFunc();
  // }, [client.client.date_created, client.client.date_registered]);

  // const date = dateFunc();

  const monthNames: string[] = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];
  return isLoading ? (
    <Loader />
  ) : (
    client && (
      <div className={st.wrapper}>
        {/*<div className={st.row}>*/}
        {/*  <div className={st.title}>Телефон</div>*/}
        {/*  <div className={st.value} onClick={() => window.open(`tel:${client?.phone}`)}>*/}
        {/*    {client?.phone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, `$1 ($2) $3-$4-$5`)}*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className={st.row}>*/}
        {/*  <div className={st.title}>E-mail</div>*/}
        {/*  <div className={st.value} onClick={() => window.open(`mailto:${client?.email}`)}>*/}
        {/*    {client?.email}*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className={cn(st.row, st.aboutLink)}>
          <div className={st.title}>О клиенте</div>
          <Link to={`/clients/clients/${client.id}/about`} onClick={doSavePageUrl}>
            <IconButton size={'small'} variant="dark">
              <ArrowRightSmall />
            </IconButton>
          </Link>
        </div>
        <div className={st.row}>
          <div className={st.title}>Дата рождения</div>
          {birth_d && (
            <div className={st.value}>{`${birth_d.getDate()} ${
              monthNames[birth_d.getMonth()]
            } ${birth_d.getFullYear()}`}</div>
          )}
        </div>
        {/*<div className={st.row}>*/}
        {/*  <div className={st.title}>Пол</div>*/}
        {/*  <div className={st.value}>{client?.gender === 'f' ? 'Женский' : 'Мужской'}</div>*/}
        {/*</div>*/}
        {/*{client?.description && (*/}
        {/*  <div className={st.row}>*/}
        {/*    <div*/}
        {/*      className={st.title}*/}
        {/*      dangerouslySetInnerHTML={{*/}
        {/*        __html: client?.description ? client?.description.replaceAll('\r', '</br>') : '',*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}
        <div className={st.row}>
          <div className={st.title}>{client?.is_registered ? 'Зарегистрирован' : 'Создан'}</div>
          <div className={st.value}>
            {registered_d !== undefined
              ? `${registered_d.getDate()} ${
                  monthNames[registered_d.getMonth()]
                } ${registered_d.getFullYear()}`
              : created_d !== undefined
                ? `${created_d.getDate()} ${monthNames[created_d.getMonth()]} ${created_d.getFullYear()}`
                : ''}
          </div>
        </div>
      </div>
    )
  );
};
